import { UntypedFormGroup } from "@angular/forms";
import { iModalTitles } from "./Interfaces/imodal-titles";
import { iHeaderButton } from "./Interfaces/iheader-buttons";
import { ModalDimension } from "./Interfaces/imodal-dimensions";
import { ModalOverflow} from "./Interfaces/imodal-overflow-options";
import { ModalColor } from "./Interfaces/imodal-colors";

export class ModalConfig {
    title!: iModalTitles;
    showTitleHint!:boolean;
    titleHint!:string;
    titleHintColor!:ModalColor
    content!: string;
    mode!: string;
    data!: any;
    header_edit! : iHeaderButton;
    header_save!: iHeaderButton;
    header_deactivate! : iHeaderButton;
    header_activate!: iHeaderButton;
    // size the modal to its content (capped at 96vh) instead of a fixed 90vh
    fitContent?: boolean;
    header_background_color! : ModalColor;
    header_title_color! : ModalColor;
    header_border_color! : ModalColor;
    show_footer!:boolean;
    formGroup: UntypedFormGroup;
    actions!: { label: string; action: () => void }[];
    width?: ModalDimension;
    height?: ModalDimension;
    borderRadius?: ModalDimension;
    overflow?: ModalOverflow;

    constructor(init?: Partial<ModalConfig>) {
        Object.assign(this, init);
    }
}
